import Button from "components/Button";
import Content from "components/Content";
import Label from "components/Label";
import text from "constants/text";
import { useRouter } from "next/router";
import React, { FC } from "react";

import Shape1 from "../../../public/shape-5.svg";
import Shape2 from "../../../public/shape-10.svg";

import { icons } from "./constants";
import styles from "./styles.module.scss";

interface Props {
  className?: string;
  labelsClassName?: string;
}

const Contact: FC<Props> = ({ className, labelsClassName }) => {
  const { title, cta, actions } = text.contact;
  const { label, to } = cta;

  const router = useRouter();

  return (
    <Content
      contentClassName={styles.container}
      containerClassName={`${styles.wrapper} ${className}`}
      id="contact-us"
    >
      <Label
        color="white"
        variant="h-centered"
        className={`${styles.title} ${labelsClassName}`}
      >
        {title}
      </Label>
      <Button
        className={styles.cta}
        variant="cta"
        onClick={() => router.push(to)}
      >
        {label}
      </Button>
      <div className={styles.actions}>
        {actions.map(({ label: aLabel, href, description, icon }) => {
          const Icon = icons[icon];

          return (
            <div className={styles.actionWrapper}>
              <a href={href}>
                <div className={styles.action}>
                  <Icon className={styles.icon} />
                  <Label
                    variant="s-capitalized"
                    className={styles.actionLabel}
                    color="primary"
                  >
                    {aLabel}
                  </Label>
                  <Label
                    variant="s"
                    className={styles.actionDescription}
                    color="primary"
                  >
                    {description}
                  </Label>
                </div>
              </a>
            </div>
          );
        })}
      </div>
      <Shape1 className={styles.shape1} />
      <Shape2 className={styles.shape2} />
    </Content>
  );
};

Contact.defaultProps = {
  className: undefined,
  labelsClassName: undefined
};

export default Contact;
